module.exports = __webpack_public_path__ + "img/dla-piper-logo.4c86c858.svg";